import React, { lazy, Suspense, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Seo from "./components/Seo";
import Home from "./pages/Home";
import { PAGES } from "./data";

// Retired or alias URLs kept working (also mirrored as 301s in vercel.json, public/_redirects and public/.htaccess).
const ALIASES = [
  ["/products/upi-qr", "/upi-qr"],
  ["/products/upi-soundbox", "/upi-soundbox"],
  ["/products/upi-payment-gateway", "/upi-payment-gateway"],
  ["/solutions/retail-merchants", "/solutions/retail-stores"],
  ["/solutions/online-businesses", "/solutions/ecommerce"],
  ["/solutions/enterprise", "/solutions/saas"],
  ["/solutions/apis-integrations", "/solutions/saas"],
];
const InnerPage = lazy(() => import("./pages/InnerPage"));
const Contact = lazy(() => import("./pages/Contact"));
const About = lazy(() => import("./pages/About"));
const UpiQr = lazy(() => import("./pages/UpiQr"));
const UpiSoundbox = lazy(() => import("./pages/UpiSoundbox"));
const UpiGateway = lazy(() => import("./pages/UpiGateway"));
const Legal = lazy(() => import("./pages/Legal"));
const Solution = lazy(() => import("./pages/Solution"));
const BusinessProduct = lazy(() => import("./pages/BusinessProduct"));
const NotFound = lazy(() => import("./pages/NotFound"));

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Seo />
      <Header />
      <main>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            {PAGES.map((p) => (
              <Route
                key={p.key}
                path={p.path}
                element={
                  p.sol ? (
                    <Solution k={p.sol} />
                  ) : p.biz ? (
                    <BusinessProduct k={p.biz} />
                  ) : p.legal ? (
                    <Legal page={p} />
                  ) : p.key === "contact" ? (
                    <Contact page={p} />
                  ) : p.key === "about" ? (
                    <About />
                  ) : p.key === "upiqr" ? (
                    <UpiQr />
                  ) : p.key === "soundbox" ? (
                    <UpiSoundbox />
                  ) : p.key === "gateway" ? (
                    <UpiGateway />
                  ) : (
                    <InnerPage page={p} />
                  )
                }
              />
            ))}
            <Route
              path="/prohibited-merchant-categories"
              element={
                <Navigate to="/page/prohibited-merchant-categories" replace />
              }
            />
            <Route
              path="/page/aml-policy"
              element={<Navigate to="/page/aml-kyc-policy" replace />}
            />
            {ALIASES.map(([from, dest]) => (
              <Route key={from} path={from} element={<Navigate to={dest} replace />} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </>
  );
}
